module.exports = __webpack_public_path__ + "static/media/nossa-historia-card.ef28ca31.jpg";